module.exports = __webpack_public_path__ + "img/otf.abf96e94.svg";